import { ToastService } from "@tylertech/forge-angular";
import { HttpErrorResponse } from "@angular/common/http";
import { ErrorPageService, IErrorRoutingState } from "../services/error-page.service";

const FIFTEEN_SECONDS = 15000;

export function getStateFromLoadError(error: any) : IErrorRoutingState {

  if (error instanceof HttpErrorResponse)
    switch (error.status) {
      case 401: return ErrorPageService.UnAuthorized;
      case 404: return ErrorPageService.NotFound;
      case 429: return ErrorPageService.TooManyRequests;
      case 0:
        if (!navigator.onLine) return ErrorPageService.Offline;
        break;
    }

  return ErrorPageService.InternalServerError;
}

export function handleSaveError(toastService: ToastService, error: any) {
  if (error instanceof HttpErrorResponse && error.status === 409) {
    const message = (error.url?.indexOf('query-types') ?? -1 >= 0) ? error.error?.message : 'Record has changed since accessed. Your changes were not saved.';
    const toast = toastService.show({
      message: message,
      actionHandler: () => toast.close(),
      placement: 'top',
      duration: FIFTEEN_SECONDS
    });
    return;
  }

  const toast = toastService.show({
    message: 'An internal error occurred. Your changes were not saved.',
    actionHandler: () => toast.close(),
    placement: 'top',
    duration: FIFTEEN_SECONDS
  });
}

export function showErrorToast(toastService: ToastService, message: string) {
  const toast = toastService.show({
    message: message,
    actionHandler: () => toast.close(),
    placement: 'top',
    duration: 5000
  });
}